<div class="product-card" [ngClass]="{'cart-height': cartEnabled}">
  <span *ngIf="product.items[selectedItem].partnerAvailability > 0" class="sale-strip">Express Delivery</span>
  <a role="button" (click)="viewSimilar = true" *ngIf="product.similarModels && product.similarModels.length">
    <i class="pi pi-clone similar-modals d-md-none"></i>
  </a>
  <a role="button" (click)="navigateURL(product)">
    <div class="product-image">
      <img src="{{ product.imageUrl.indexOf('https://images.smartdukaan.com/uploads/campaigns') < 0 ? product.imageUrl : 'https://images.smartdukaan.com/uploads/campaigns/Image-not-available_1.jpg' }}" [alt]="product.title" title="{{product.title}}"/>
    </div>
    <h4 class="product-title" title="{{product.title}}"><strong>{{modifyTitle(product.title)}}</strong></h4>
  </a>
  <div class="product-details row">
    <a role="button" (click)="navigateURL(product)">
      <p class="product-price">
        <span class="product-title me-1" *ngIf="product.items[selectedItem].mrp != product.items[selectedItem]?.mop">
          <small class="product-title  text-decoration-line-through">{{ product.items[selectedItem]?.mrp | currency:"INR" }}</small>
        </span>
        <small class="badge bg-danger discount fs-7 my-1" *ngIf="product.items[selectedItem].mrp != product.items[selectedItem].mop">{{calculateDiscount(product.items[selectedItem])}}</small>
      </p>
      <span class="fs-5 text-danger fw-bold me-1 mb-2">{{ (product.items[selectedItem].mop - product.items[selectedItem].cashback) | currency:"INR" }}</span>
    </a>
    <div *ngIf="cartEnabled && product.items[selectedItem].availability > 0" class="">
      <small> <button type="button" class="btn btn-sm btn-outline-danger" (click)="addToCart(product)"><i class="pi pi-shopping-cart"></i> Add To Cart</button></small>
    </div>
    <div class="text-center" *ngIf="product.items[selectedItem].availability == 0">
      <strong class="text-warning">Out Of Stock</strong>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="viewSimilar" position="bottom">
  <ng-template pTemplate="headless">
    <div class="card">
      <div class="card-header">
        <div class="flex align-items-center gap-2">
          <h5 class="fw-bold">
            <img src="{{ product.imageUrl.indexOf('https://images.smartdukaan.com/uploads/campaigns') < 0 ? product.imageUrl : 'https://images.smartdukaan.com/uploads/campaigns/Image-not-available_1.jpg' }}" width="50" [alt]="product.title" title="{{ product.title }}"/>
            More like this
            <a role="button" class="float-end" (click)="viewSimilar = false"><i class="pi pi-times-circle"></i></a></h5>
        </div>
      </div>
      <div class="card-body">
        <div class="overflow-y-auto container my-4">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-md-2" *ngFor="let similar of product.similarModels">
                <a role="button" (click)="navigateURL(similar)">
                  <div class="row similar-product-listing h-100">
                    <div class="col-md-3 image-container">
                      <img src="{{ similar.imageUrl.indexOf('https://images.smartdukaan.com/uploads/campaigns') < 0 ? similar.imageUrl : 'https://images.smartdukaan.com/uploads/campaigns/Image-not-available_1.jpg' }}" class="img-fluid similar-product-image" [alt]="similar.title" title="{{ similar.title }}"/>
                    </div>
                    <div class="col-md-9">
                      <h5 class="similar-product-title">{{ similar.title }}</h5>
                      <p class="similar-product-price fw-bold">{{ (similar.dp | currency:"INR") || 'N/A' }}</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-sidebar>
